export default {
  name: 'category',
  translationKey: 'category-module',
  routePrefix: 'category',
  routeNamePrefix: 'admin.category',
  directRoutesAvailable: false,
}
